//Helpers
import { mathNormalize } from 'src/helpers/utilities';
import { rangeDates, rangeOptions } from 'src/components/Chart/chart_control_helpers';
import { getPVSetupByType, getPVSetupChartsConfig, getPVSetupDevices } from './pv_setup_helper';
//Types
import type { PVSetupTypes } from './pv_setup_helper';
import type { ChartConfig, ChartDataInterface } from 'src/types/Chart';
import type { chartControlsDataInterface } from 'src/components/Chart/chart_control_helpers';

type SelfConsumptionResult = {
	savingsToday: number; // Savings today в Wh
	selfConsumption: number; // Self-consumption в %
};

export const CACHE_PV_SELF_CONSUMPTION_TIMEOUT = 60000 * 5;

export const calculateSelfConsumption = async (
	pvSetupType: PVSetupTypes,
): Promise<SelfConsumptionResult> => {
	const statsData: ChartDataInterface = await getStatsPeriod(pvSetupType);
	const totals = statsData?.totalConsumption || [];
	const solar = totals.find((t) => t.name === 'pv')?.rawValue ?? 0;
	const exp = totals.find((t) => t.name === 'exported')?.rawValue ?? 0;
	const savingsToday = Math.max(0, solar - exp);
	const selfConsumption = solar > 0 ? (savingsToday / solar) * 100 : 0;
	return { savingsToday, selfConsumption: mathNormalize(selfConsumption, 0, 100) };
};

const getStatsPeriod = async (pvSetupType: PVSetupTypes): Promise<ChartDataInterface> => {
	const chartConfig: ChartConfig = getPVSetupChartsConfig();
	const today = new Date();
	const currentPeriod = 'day';
	const rangeOption = rangeOptions.find((i) => i.period == currentPeriod);
	const time = rangeDates(today, rangeOption);
	const chartControlsData: chartControlsDataInterface = {
		time,
		format: 'Y-m-d H:i:s',
		rangeOption,
		currentPeriod,
	};
	const pvSetupDevices = getPVSetupDevices(pvSetupType);
	return getPVSetupByType(
		pvSetupDevices.gridDevices,
		pvSetupDevices.solarDevices,
		pvSetupType,
		chartConfig,
		chartControlsData,
	);
};
